import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient/flowbee/FlowbeeApiClient'

export default {
	async [actionTypes.FLOWBEE.BUSCAR_CONFIGURACOES](context, header) {
		const { data } = await api.buscarConfiguracoes(header)
		return data
	},
}
